/**
 * Create an array with numbers starting from "from" with step "step" of length "length"
 *
 * @param options - options
 * @return - array of distributed numbers with step "step" from "from"
 */
export function createStepArray(options = {}) {
    let { from = 0, step = 1, length = 1000 } = options;
    const array = new Float64Array(length);
    let index = 0;
    while (index < length) {
        array[index] = from + step * index;
        index++;
    }
    return array;
}
//# sourceMappingURL=createStepArray.js.map